module.exports = __webpack_public_path__ + "static/media/rick-and-morty-logo.75509f2e.png";